import { render, staticRenderFns } from "./TranslucentTable.vue?vue&type=template&id=0e08413b"
import script from "./TranslucentTable.vue?vue&type=script&lang=js"
export * from "./TranslucentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports